import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useAuth } from '../../commons/Auth';
import { useLoading } from '../../commons/Loading';
import { useAlert } from 'react-alert';
import AgreementDetailsPresentational from './AgreementDetailsPresentational';
import { NumberParam, useQueryParams, withDefault } from 'use-query-params';
import axios from 'axios';
import { getSignedUrl, getYousignFile } from '../../lib/fetch/files';
import './AgreementsDetail.scss';

const { REACT_APP_DEFAULT_PAGINATION_LIMIT = 50 } = process.env;

const AgreementsDetailAdmin = (props) => {
  const { id: agreementId } = useParams();
  const [t] = useTranslation('AGREEMENTS');
  const [{ newToken, newIsAdmin } = {}] = useAuth();
  const { showLoading, hideLoading } = useLoading();
  const alert = useAlert();

  const [agreement, setAgreement] = useState({});
  const [attachments, setAttachments] = useState([]);
  const [totalAttachments, setTotalAttachments] = useState(0);

  const [query, setQuery] = useQueryParams({
    limit: withDefault(NumberParam, +REACT_APP_DEFAULT_PAGINATION_LIMIT),
    offset: NumberParam,
  });

  const { limit, offset } = query;

  useEffect(() => {
    fetchAgreement();
  }, [limit, offset, agreementId]);

  const fetchAgreement = async () => {
    showLoading();

    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/agreements/details/${agreementId}`,
      {
        headers: { Authorization: newToken },
        params: {
          limit,
          offset,
        },
      }
    );

    hideLoading();

    if (response instanceof Error) {
      return alert.error(t('COMMON:GENERIC_ERROR'));
    }

    const { data = {} } = response;
    setAgreement(data);
    setAttachments(data.attachments);
    setTotalAttachments(data.attachments?.length);
  };

  function onFilter(queryDiff) {
    if (queryDiff.limit && queryDiff.limit !== limit) {
      queryDiff.offset = 0;
    }

    setQuery(queryDiff);
  }

  async function handleFileSigned(signingRequestId) {
    showLoading();

    const { data, error, headers } = await getYousignFile(signingRequestId);

    if (error) {
      hideLoading();
      alert.error(t('COMMON:GENERIC_ERROR'));
      return;
    }
    hideLoading();

    const file = new Blob([data], { type: headers['content-type'] });
    const fileURL = URL.createObjectURL(file);
    window.open(fileURL, '_blank');
  }

  async function handleFileListView(key) {
    showLoading();

    const { data, error } = await getSignedUrl(key, newToken);

    if (error) {
      hideLoading();
      alert.error(t('COMMON:GENERIC_ERROR'));
      return;
    }

    hideLoading();
    window.open(data.url, '_blank');
  }

  return (
    <AgreementDetailsPresentational
      data={agreement}
      attachments={attachments}
      total={totalAttachments}
      offset={offset}
      limit={limit}
      onFilter={onFilter}
      query={query}
      handleFileSigned={handleFileSigned}
      handleFileListView={handleFileListView}
    />
  );
};

export default AgreementsDetailAdmin;
